import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone } from "lucide-react";
import { INFO } from "@/lib/data";
import { scrollToId } from "./SmoothScroll";

export default function Footer() {
  return (
    <footer className="bg-charcoal text-bone/80 pt-20 pb-32 lg:pb-14 grain relative">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-10 pb-14 border-b border-bone/10">
          <div className="md:col-span-2">
            <div className="font-serif text-4xl text-bone leading-none">Bar Ristorante Gabri</div>
            <div className="text-[10px] tracking-[0.34em] uppercase text-terracotta mt-2">Cavi di Lavagna · Riviera Ligure</div>
            <p className="mt-5 max-w-sm font-sans text-sm leading-relaxed text-bone/60">
              Bar, ristorante e gelateria nel cuore di Cavi di Lavagna. Colazioni,
              aperitivi, gelati artigianali e cucina di mare ligure, tutti i giorni.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={INFO.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 grid place-items-center border border-bone/20 rounded-sm hover:bg-terracotta hover:border-terracotta transition-colors duration-300">
                <Instagram size={18} />
              </a>
              <a href={`tel:${INFO.phoneTel}`} aria-label="Telefono" className="h-10 w-10 grid place-items-center border border-bone/20 rounded-sm hover:bg-terracotta hover:border-terracotta transition-colors duration-300">
                <Phone size={18} />
              </a>
              <a href={INFO.mapLink} target="_blank" rel="noopener noreferrer" aria-label="Mappa" className="h-10 w-10 grid place-items-center border border-bone/20 rounded-sm hover:bg-terracotta hover:border-terracotta transition-colors duration-300">
                <MapPin size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide text-bone/50 mb-4 font-sans">Naviga</div>
            <ul className="flex flex-col gap-2.5 font-sans text-sm">
              {[
                { id: "menu", l: "Menu" },
                { id: "galleria", l: "Galleria" },
                { id: "chi-siamo", l: "Chi siamo" },
                { id: "recensioni", l: "Recensioni" },
                { id: "prenota", l: "Prenotazioni" },
                { id: "contatti", l: "Contatti" },
              ].map((x) => (
                <li key={x.id}>
                  <button onClick={() => scrollToId(x.id)} className="hover:text-terracotta transition-colors duration-300">
                    {x.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide text-bone/50 mb-4 font-sans">Contatti</div>
            <ul className="flex flex-col gap-2.5 font-sans text-sm text-bone/70">
              <li>{INFO.street}</li>
              <li>{INFO.cap} {INFO.city} ({INFO.province})</li>
              <li><a href={`tel:${INFO.phoneTel}`} className="hover:text-terracotta">{INFO.phoneDisplay}</a></li>
              <li>{INFO.hours}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-bone/50 font-sans">
          <span>© {new Date().getFullYear()} Bar Ristorante Gabri · P. IVA IT01226470993 · Lavagna (GE)</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-terracotta transition-colors">Privacy Policy</Link>
            <Link to="/cookie" className="hover:text-terracotta transition-colors">Cookie Policy</Link>
            <Link to="/termini" className="hover:text-terracotta transition-colors">Termini e Condizioni</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
